import { render } from "./markdown_content.vue?vue&type=template&id=4a6014d4"
import script from "./markdown_content.vue?vue&type=script&lang=js"
export * from "./markdown_content.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__